/** Persist settings section + scroll so refresh returns you where you were. */

const SECTION_KEY = (guildId) => `kami_settings_section_${guildId}`;
const SCROLL_KEY = (path) => `kami_scroll_${path}`;

export function readSettingsSection(guildId) {
  if (!guildId || typeof window === "undefined") return null;
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("section");
    if (fromUrl) return fromUrl;
    return localStorage.getItem(SECTION_KEY(guildId));
  } catch {
    return null;
  }
}

export function writeSettingsSection(guildId, sectionId) {
  if (!guildId || !sectionId || typeof window === "undefined") return;
  try {
    localStorage.setItem(SECTION_KEY(guildId), sectionId);
  } catch {
    /* quota / private mode */
  }
}

export function readScrollY(pathKey) {
  if (!pathKey || typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(SCROLL_KEY(pathKey));
    if (raw == null) return null;
    const y = Number(raw);
    return Number.isFinite(y) ? y : null;
  } catch {
    return null;
  }
}

export function writeScrollY(pathKey, y) {
  if (!pathKey || typeof window === "undefined") return;
  try {
    sessionStorage.setItem(SCROLL_KEY(pathKey), String(Math.max(0, y | 0)));
  } catch {
    /* ignore */
  }
}

/**
 * Restore scroll once after mount, then keep writing on scroll.
 * @returns cleanup function
 */
export function bindScrollMemory(pathKey, { restoreDelayMs = 50 } = {}) {
  if (!pathKey || typeof window === "undefined") return () => {};

  const saved = readScrollY(pathKey);
  let restored = false;
  const restore = () => {
    if (restored || saved == null) return;
    restored = true;
    window.scrollTo(0, saved);
  };

  const t1 = window.setTimeout(restore, restoreDelayMs);
  const t2 = window.setTimeout(restore, 300);

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      writeScrollY(pathKey, window.scrollY || window.pageYOffset || 0);
      ticking = false;
    });
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  return () => {
    window.clearTimeout(t1);
    window.clearTimeout(t2);
    window.removeEventListener("scroll", onScroll);
    writeScrollY(pathKey, window.scrollY || window.pageYOffset || 0);
  };
}
